import { render, staticRenderFns } from "./PhieuThuChi.vue?vue&type=template&id=d8d5e498&"
import script from "./PhieuThuChi.vue?vue&type=script&lang=js&"
export * from "./PhieuThuChi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports